export default __webpack_public_path__ + "static/media/enghien24.3285014b.jpg";